import type { MouseEvent } from 'react'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { useBottomSheet } from '../../../../state-management/contexts/BottomSheetContext'
import { lightImpactVibrate } from '../../../../utils/appBridge'
import {
  EliteEsignSupportLearnMoreBottomSheet,
  resolveSupportTextDisplayHtml
} from '../../../new-elite-landing/components/NewEliteLandingPlanSelector'
import { ElitePlansEventId, trackElitePlansClick } from '../../analytics'
import { useElitePlansLanding } from '../../ElitePlansLandingContext'

type ElitePlansSupportTextProps = {
  supportText: string
  planId: string
}

/** Renders lifecycle/advisory support copy; trusted learn-more HTML opens the eSign sheet. */
export function ElitePlansSupportText({ supportText, planId }: ElitePlansSupportTextProps) {
  const { status } = useElitePlansLanding()
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const activationExpiryDate = status?.subscriptionDetails?.activationExpiryDate
  const supportDisplayHtml = resolveSupportTextDisplayHtml(supportText, activationExpiryDate)
  if (!supportDisplayHtml) return null

  const supportHasLearnMoreLink = supportDisplayHtml.includes('data-elite-plan-learn-more')

  const handleSupportAreaClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!(event.target as HTMLElement).closest('[data-elite-plan-learn-more]')) return
    lightImpactVibrate()
    trackElitePlansClick(ElitePlansEventId.ViewDetails, {
      planId,
      buttonLabel: 'Learn more'
    })
    openBottomSheet(
      <EliteEsignSupportLearnMoreBottomSheet
        onDismiss={closeBottomSheet}
        activationExpiryDate={activationExpiryDate}
      />
    )
  }

  return (
    <div role='status'>
      <RenderHTML
        innerHTMLText={supportDisplayHtml}
        className='ep-theme-tween mt-4 w-full text-center text-13 font-medium leading-[1.45] text-status-text-out-of-form'
        onClick={supportHasLearnMoreLink ? handleSupportAreaClick : undefined}
      />
    </div>
  )
}
